import { Button } from '@carbon/react';
import { Settings } from '@carbon/react/icons';


export const SetPreferencesButton = ({ onClick, ...remainingProps }) => {
  return (
    <Button
      kind="ghost"
      renderIcon={ props => <Settings style={{ marginLeft: '0.5em' }} { ...props } /> }
      onClick={ onClick }
      { ...remainingProps }
    >
      Set Preferences
    </Button>
  );
};